import {
  CollectionActions,
  CollectionStateSlice,
  mergeDocuments,
  mergeWebsocketDocuments,
  transformIntoDocuments,
} from '@freelancer/datastore/core';
import { transformFeedPost } from './feed-posts.transformers';
import { FeedPostsCollection } from './feed-posts.types';

export function feedPostsReducer(
  state: CollectionStateSlice<FeedPostsCollection> = {},
  action: CollectionActions<FeedPostsCollection>,
) {
  switch (action.type) {
    case 'API_PUSH_SUCCESS': {
      if (action.payload.type === 'feedPosts') {
        const { result, ref } = action.payload;
        return mergeWebsocketDocuments<FeedPostsCollection>(
          state,
          transformIntoDocuments([result.post], transformFeedPost),
          ref,
        );
      }
      return state;
    }

    case 'API_FETCH_SUCCESS': {
      if (action.payload.type === 'feedPosts') {
        const { result, ref, order } = action.payload;
        return mergeDocuments<FeedPostsCollection>(
          state,
          transformIntoDocuments(result.posts, transformFeedPost),
          order,
          ref,
        );
      }
      return state;
    }

    default:
      return state;
  }
}
